import { Component, OnInit } from '@angular/core';
import { ReporteService } from '@app/core/service/reporte.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CategoryService, ProductService } from '@app/core';
import { Category } from '@core/model/category.model';
import { Product } from '@core/model/product.model';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-existencia',
  templateUrl: './existencia.component.html',
  styleUrls: ['./existencia.component.css']
})
export class ExistenciaComponent implements OnInit {
  inicio: string;
  final: string;
  existencia: any;
  existencia2: any;
  buscarForm: FormGroup;
  categories: Category[];
  products: Product[];
  isLoading = false;

  todos: number;
  flag = false;

  constructor(
    private reporteService: ReporteService,
    private categoryService: CategoryService,
    private productoService: ProductService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.createForm();
    this.listData();
   // this.ListarExistencia();
  }

  createForm() {
    this.buscarForm = this.formBuilder.group({
      inicio: [
        new Date().toISOString().substring(0, 10),
        [Validators.required]
      ],
      fin: [new Date().toISOString().substring(0, 10), [Validators.required]],
      categoria: ['', [Validators.nullValidator]],
      producto: ['', [Validators.nullValidator]],
    //  comprobante: ['', [Validators.nullValidator]]

      /*   categoria: ['',[Validators.required]],
      producto:['',[Validators.required]]*/
    });
  }
  getSelectedProduct(event: Product) {
    // alert(event);

    console.log('Producto Changed: ' + event.producto_id);
    // console.log(JSON.stringify(event));
    // this.resetPurchase();
    // this.showDiv = null;
    // console.log(i);
    this.todos = event.producto_id;
    //  this.patchValues(event.producto_id, i);
    // this.addressCustomer = event.address;
  }

  listData() {
    // listando cattegorias
    this.categoryService.getCategoriasHabilitdas().subscribe(
      data => {
        console.log(data);
        this.categories = data;
      },
      error => {
        console.log(error);
      }
    );
    // listtando producto
    this.productoService.getProductosExistencia().subscribe(
      data => {
        //  console.log(data);
        this.products = data;
      },
      error => {
        console.log(error);
      }
    );
  }

  ListarExistencia() {
    /* const data = {
       fecha_inicio: '2019/11/02',
       fecha_final: '2019/12/02'
     };*/
    const fechaActual = new Date();
    const dia = fechaActual.getDate().toString();
    const mes = (fechaActual.getMonth() + 1).toString();
    const anio = fechaActual.getFullYear().toString();
    // alert(mes);
    const data = {
      fecha_inicio: anio + '/' + mes + '/' + dia,
      fecha_final: anio + '/' + mes + '/' + dia,
      categoria_id: 0
    };
    //  console.log(data);
    // alert(this.i/**/nicio);
    this.isLoading = true;
    this.reporteService.existencia(data).pipe(
      finalize(() => {
        this.buscarForm.markAsPristine();
        this.isLoading = false;
      })
    )
    .subscribe(
      data2 => {
           console.log(data2);
        this.existencia = data2;
        this.existencia2 = data2;

      },
      error1 => {
        console.log(error1);
      }
    );
  }

  buscarExistencia() {
    let data = {};
    this.isLoading = true;
    if (this.todos !== undefined) {
      data = {
        producto_id: this.buscarForm.value.producto,
        categoria_id: this.buscarForm.value.categoria,
        fecha_inicio: this.buscarForm.value.inicio,
        fecha_final: this.buscarForm.value.fin
      };
    } else {
      data = {
        producto_id: 0,
        fecha_inicio: this.buscarForm.value.inicio,
        fecha_final: this.buscarForm.value.fin
      };
    }

    this.reporteService.existencia(data).pipe(
      finalize(() => {
        this.buscarForm.markAsPristine();
        this.isLoading = false;
      })
    )
    .subscribe(
      data2 => {
        // console.log(data2);
        this.existencia = data2;
        this.existencia2 = data2;
      },
      error1 => {
        console.log(error1);
      }
    );

    

  }
  
  disponibles()
  {
    
    const arr1 = this.existencia.filter((d:any) => d.existencia > 0);
   // console.log(arr1);
    this.existencia = arr1;

  }
  normal()
  {
    const arr2 = this.existencia2.filter((d:any) => d.existencia >= 0);
   // console.log(arr1);
    this.existencia = arr2;

  }

  
  checkStatus(stock: Number, lim: Number) {
    if (stock <= lim) {
      return false;
    } else {
      return true;
    }
  }
}
